import React from "react";

import { DownMinimalArrow, Delete } from "icons";
import Pluralize from "pluralize";
import { isEmpty } from "ramda";

import {
  DropdownOverlay,
  Typography,
  SearchBar,
  Checkbox,
  Button,
} from "clearsense-ui/components";
import AnimatedAction from "components/Common/AnimatedAction";
import PermissibleWrapper from "components/Common/PermissibleWrapper";
import {
  FILTER_CONDITIONS,
  FILTER_OPERATIONS,
} from "components/DataManagement/constants/stewardFilter";
import hyphenize from "utils/hyphenize";

import Filter from "./Filter";

const FilterHeader = ({
  entity = "Entity",
  filterParams,
  columnHeaderSelector,
  count = 0,
  filterConditions = [],
  setFilterConditions = () => {},
  checkedRows = [],
  setIsDeleteAlertOpen = () => {},
  userPermissions = [],
  columnOptions = [],
}) => {
  const { columns, toggleVisibility } = columnHeaderSelector;
  return (
    <div className="flex justify-between my-4 w-full mt-8">
      <div className="flex items-center w-2/6 space-x-4">
        <Typography style="large" type="bold" data-testid="domain-count-text">
          {Pluralize(entity, count, true)}
        </Typography>
        <Filter
          count={count}
          title={entity}
          filterConditions={filterConditions}
          setFilterConditions={setFilterConditions}
          columnOptions={columnOptions
            ?.filter(column => column !== "Action")
            .map(column => ({
              label: column,
              value: column,
            }))}
          conditionOptions={FILTER_CONDITIONS}
          filterOperations={FILTER_OPERATIONS}
        />
        <PermissibleWrapper
          currentPermissions={userPermissions}
          acceptablePermissions="destroy"
        >
          <AnimatedAction>
            {!isEmpty(checkedRows) && (
              <Button
                label="Delete"
                icon={Delete}
                className="text-red-700 hover:bg-gray-300"
                style="secondary"
                onClick={() => setIsDeleteAlertOpen(true)}
                data-testid="delete-button"
                data-cy={`delete-${hyphenize(entity.toLowerCase())}-button`}
              />
            )}
          </AnimatedAction>
        </PermissibleWrapper>
      </div>
      <div
        className="flex items-center w-3/6 space-x-4"
        data-cy={`${hyphenize(
          entity.toLowerCase()
        )}-subheader-right-action-block-div`}
      >
        <SearchBar
          placeholder="Search"
          className="w-72"
          value={filterParams.search}
          onChange={e => filterParams.setSearch(e.target.value)}
        />
        <div
          className="flex gap-4"
          data-cy={`${hyphenize(
            entity.toLowerCase()
          )}-table-edit-column-button-div`}
        >
          <DropdownOverlay
            buttonLabel="Edit Columns"
            buttonStyle="secondary"
            buttonProps={{
              icon: DownMinimalArrow,
              iconPosition: "right",
              disabled: !count,
            }}
          >
            <div
              className="p-4 pb-0"
              data-cy={`${hyphenize(
                entity.toLowerCase()
              )}-table-enabled-columns-div`}
            >
              <Typography
                style="h6"
                className="mb-2 uppercase text-grey-medium-shade"
              >
                enabled
              </Typography>
              {columns?.selected?.map(column => (
                <Checkbox
                  key={column.key}
                  label={column.title}
                  id={column.key}
                  className="mb-5"
                  onClick={e =>
                    columns.selected.length > 1 && toggleVisibility(e.target.id)
                  }
                  checked
                  readOnly
                  disabled={columns.selected.length === 1}
                />
              ))}
            </div>
            <div
              className="px-4"
              data-cy={`${hyphenize(
                entity.toLowerCase()
              )}-table-disabled-columns-div`}
            >
              <Typography
                style="h6"
                className="mb-2 uppercase text-grey-medium-shade"
              >
                disabled
              </Typography>
              {columns?.unSelected?.map(column => (
                <Checkbox
                  key={column.key}
                  label={column.title}
                  id={column.key}
                  className="mb-5"
                  onClick={e => toggleVisibility(e.target.id)}
                  readOnly
                />
              ))}
            </div>
          </DropdownOverlay>
        </div>
      </div>
    </div>
  );
};

export default FilterHeader;
